var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-profile-supply';
                    var viewUrl = 'sprite.svg#view-icon-profile-supply';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 80 56',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };